module.exports = __webpack_public_path__ + "static/media/table1.1ba4b939.png";